import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { getNumberColor } from '../utils/roulette';

export const ResultModal = ({ isOpen, onClose, winningNumber, winningBets, totalWon }) => {
  if (!isOpen || winningNumber === null) return null;

  const color = getNumberColor(winningNumber);
  const bgClass = color === 'red' ? 'bg-[#b01e23]' : color === 'black' ? 'bg-[#13161c]' : 'bg-[#0a5c36]';

  return (
    <AnimatePresence>
      <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
        <motion.div
          initial={{ opacity: 0, scale: 0.9, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.9, y: 20 }}
          className="bg-[#13151b] border border-gray-800 rounded-2xl shadow-2xl overflow-hidden max-w-md w-full relative"
        >
          <button 
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-400 hover:text-white z-10"
          >
            <X size={24} />
          </button>
          
          <div className="p-8 text-center flex flex-col items-center">
            <h3 className="text-gray-400 font-bold uppercase tracking-widest text-sm mb-6">SPIN RESULT</h3>
            
            <div className={`w-32 h-32 rounded-full ${bgClass} border-4 border-charcoal-900 shadow-[0_0_30px_rgba(0,0,0,0.5)] flex items-center justify-center mb-8 relative`}>
               <div className="absolute inset-2 border-2 border-white/20 rounded-full border-dashed pointer-events-none" />
               <span className="text-6xl font-bold text-white shadow-sm">{winningNumber}</span>
            </div>

            {totalWon > 0 ? (
              <div className="space-y-2">
                <h4 className="text-3xl font-serif text-gold-500">You Won!</h4>
                <p className="text-2xl font-bold text-white">+ ${totalWon}</p>
                <p className="text-gray-400 text-sm mt-4">
                  Winning bets: {winningBets.map(b => b.type).join(', ')}
                </p>
              </div>
            ) : (
              <div className="space-y-2">
                <h4 className="text-2xl font-serif text-gray-300">No Luck This Time</h4>
                <p className="text-gray-500 text-sm mt-2">Try another bet to win.</p>
              </div>
            )}
            
            <button
              onClick={onClose}
              className="mt-8 w-full py-4 bg-gray-800 hover:bg-gray-700 text-white font-bold rounded-full uppercase tracking-wider transition-colors"
            >
              CONTINUE
            </button>
          </div>
        </motion.div>
      </div>
    </AnimatePresence>
  );
};
